<template>
  <div class="app-container reimbursement-manager">
    <div style="height: 100%; display: flex;flex-direction: column">
      <div ref="search" class="search-content" style="margin-top: 10px;">
        <el-form :inline="true" label-position="right" label-width="100px">
          <el-form-item label="品牌：" style="width: 320px;">
            <el-select v-model="queryForm.brand_id" class="order-list-search-item" filterable clearable collapse-tags popper-class="select-all" style="width: 180px" @change="changeBrand">
              <el-option v-for="(v, k) in brands" :key="k" :value="v.id" :label="v.brand_en" />
            </el-select>
          </el-form-item>
          <el-form-item label="城市：" style="width: 320px;">
            <el-select v-model="queryForm.city_id" class="order-list-search-item" filterable clearable collapse-tags popper-class="select-all" style="width: 180px" @change="changeCity">
              <el-option v-for="(v, k) in cities" :key="k" :value="v.id" :label="v.city_cn" />
            </el-select>
          </el-form-item>
          <el-form-item label="商场：" style="width: 320px;">
            <el-select v-model="queryForm.market_id" filterable clearable collapse-tags popper-class="select-all" style="width: 180px" @change="changeMarket">
              <el-option v-for="(v, k) in markets" :key="k" :value="v.id" :label="v.market_cn" />
            </el-select>
          </el-form-item>
          <el-form-item label="店铺：" style="width: 320px;">
            <el-select v-model="queryForm.store_id" filterable clearable collapse-tags popper-class="select-all" style="width: 180px">
              <el-option v-for="(v, k) in shops" :key="k" :value="v.id" :label="v.name_cn" />
            </el-select>
          </el-form-item>
          <el-form-item label="报告模板：" style="width: 320px;">
            <el-select v-model="queryForm.report_tid" filterable clearable collapse-tags popper-class="select-all" style="width: 180px">
              <el-option v-for="(v, k) in models" :key="k" :value="v.id" :label="v.title" />
            </el-select>
          </el-form-item>
          <el-form-item label="报修类型：" style="width: 320px;">
            <el-select v-model="queryForm.ma_type" class="order-list-search-item" filterable clearable collapse-tags popper-class="select-all" style="width: 180px" @change="changeMaType">
              <el-option v-for="(v, k) in ma_type_list" :key="k" :value="k" :label="v" />
            </el-select>
          </el-form-item>
          <el-form-item label="报修类目：" style="width: 320px;">
            <el-select v-model="queryForm.ma_cate_id" class="order-list-search-item" filterable clearable collapse-tags popper-class="select-all" style="width: 180px">
              <el-option v-for="(v, k) in ma_cate_list" :key="k" :value="v.id" :label="v.cn_name ? v.cn_name : v.en_name" />
            </el-select>
          </el-form-item>
          <el-form-item label=" " style="width: 320px">
            <el-button type="primary" @click="returnBack">返回</el-button>
            <el-button v-loading="loading" type="primary" @click="queryList">查询</el-button>
            <el-button type="primary" @click="newCreate">新建</el-button>
          </el-form-item>
        </el-form>
      </div>

      <el-table
        :data="result.list"
        border
        :style="{width: '100%', height: tableHeight }"
      >
        <el-table-column label="序号" type="index" fixed min-width="100px" align="center" />
        <el-table-column label="报告单编号" fixed min-width="120px" align="left">
          <template slot-scope="scope">
            <span style="color: #3a8ee6;cursor: pointer" @click="showReport(scope.row)">{{ scope.row.report_no }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单编号" fixed min-width="120px" align="left">
          <template slot-scope="scope">
            <span style="color: #3a8ee6;cursor: pointer" @click="showOrder(scope.row)">{{ scope.row.order_no }}</span>
          </template>
        </el-table-column>
        <el-table-column label="申请日期" prop="create_at" min-width="100px" align="center" />
        <el-table-column label="品牌" prop="brand_en" min-width="100px" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.brand_en }}</span>
          </template>
        </el-table-column>
        <el-table-column label="城市" prop="city_cn" min-width="80px" align="center" />
        <el-table-column label="商场" prop="market_cn" min-width="100px" align="center" />
        <el-table-column label="店铺" prop="store_cn" min-width="120px" align="left" />
        <el-table-column label="维修类型" prop="ma_type_cn" min-width="100px" align="left" />
        <el-table-column label="工作类型" prop="a_cate_cn" min-width="180px" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.ma_cate_cn }}</span>
          </template>
        </el-table-column>
        <el-table-column label="完工时间" prop="completed_at" min-width="150px" align="center" />
        <el-table-column label="创建人" prop="creator_name" min-width="150px" align="center" />
        <el-table-column label="模板类型" prop="report_title" min-width="150px" align="center" />
        <el-table-column label="操作" width="220px">
          <template slot-scope="scope">
            <el-button type="primary" style="cursor: pointer;" @click="showReport(scope.row)">编辑</el-button>
            <el-button type="primary" style="cursor: pointer" @click="createOrderReport(scope.row)">追加报告</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        :page-sizes="[20]"
        :current-page="queryForm.page"
        :page-size="queryForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="result.cnt"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <el-drawer
      v-if="showCreateReport"
      title="报告单"
      :visible.sync="showCreateReport"
      :direction="direction"
      size="50%"
      :before-close="handleClose">
      <report v-if="showCreateReport" :visible.sync="showCreateReport" :report-id="report_id" :ma-item-id="ma_item_id" :order-id="order_id" :order-supplier-id="order_supplier_id" :order-detail="order_detail" @hideDetail="hideReport" @refresh="refreshData" />
    </el-drawer>
    <el-drawer
      v-if="showNewCreateReport"
      title="新建报告单"
      :visible.sync="showNewCreateReport"
      :direction="direction"
      size="50%"
      :before-close="handleClose">
      <new-report-pc v-if="showNewCreateReport" :visible.sync="showNewCreateReport" @hideDetail="hideCreateReport" @refresh="refreshData" />
    </el-drawer>
  </div>
</template>

<script>
import { getBrandList, getCityList, getMarketList, getShopList } from '@/api/order'
import { getReportList, getReportTemplateList} from '../../api/report'
import {getMaCateLv1List} from "../../api/order";
import Report from './components/create-report-pc'
import NewReportPc from './components/new-report-pc'

const COLOR_TYPES = {
  'red': 'danger',
  'yellow': 'warning',
  'blue': 'primary',
  'green': 'success'
}

export default {
  name: 'ReportList',
  components: {
    Report,
    NewReportPc
  },
  data() {
    return {
      showNewCreateReport: false,
      ma_type_list: {
        urgent: '紧急维修',
        not_urgent: '固定维保'
      },
      order_detail: {},
      colorTypes: COLOR_TYPES,
      loading: false,
      exportLoading: false,
      tableHeight: '100%',
      showCreateReport: false,
      nextPageLoading: false,
      switchLoading: false,
      showBrand: true,
      imageDialog: false,
      imageList: [],
      report_id: 0,
      initData: {
        states: [],
        users: [],
        brands: [],
        cities: [],
        marketMap: []
      },
      ea_id: undefined,
      showReimbursement: false,
      direction: 'rtl',
      countData: [],
      queryForm: {
        reim_no: '',
        city: '',
        market_id: '',
        title: '',
        states: [],
        userIds: [],
        brandIds: [],
        applyDate: [],
        completeDate: [],
        hasReceipts: '',
        hasAdvanced: '',
        hasUpdated: '',
        hasReport: '',
        hasQuotation: '',
        page: 1,
        pageSize: 20
      },
      brands: [],
      cities: [],
      markets: [],
      shops: [],
      operationRecords: [],
      operationRecordsDialog: false,
      pageSizes: [20, 50, 100, 200],
      result: {
        list: [],
        cnt: 0
      },
      quotationDialog: false,
      reportDialog: false,
      detailData: {},
      currentFileId: 0,
      currentFileType: '',
      appo_task_id: 0,
      reim_id: 0,
      ma_item_id: 0,
      models: [],
      ma_cate_list: [],
      order_id: 0,
      order_supplier_id: 0
    }
  },
  async created() {
    const { brand_id } = this.$route.meta
    if (brand_id) {
      this.queryForm.brand_id = [brand_id]
    }
    document.title = '报告单管理'
    await this.getList()
    this.getBrandList()
    this.getCityList()
    this.getModels()
  },
  mounted() {
    this.tableHeight = document.documentElement.clientHeight - this.$refs.search.offsetHeight - 50 + 'px'
  },
  methods: {
    newCreate() {
      this.showNewCreateReport = true
    },
    showOrder(row) {
      this.$router.push({path: '/warranty_detail', query: {ma_item_id: row.ma_item_id, appo_task_id: row.appo_task_id}})
    },
    returnBack() {
      this.$router.go(-1)
    },
    refreshData() {
      this.getList()
      this.$forceUpdate()
    },
    changeMaType() {
      getMaCateLv1List({ p_type: this.queryForm.ma_type === 'urgent' ? 'non_fix' : 'fix' }).then((res) => {
        if (res.data.data) {
          this.ma_cate_list = res.data.data
          this.ma_sub_cate_list = []
        }
      })
    },
    getModels() {
      getReportTemplateList().then((res) => {
        if (res.data.data) {
          this.models = res.data.data
        }
      })
    },
    hideReport() {
      this.showCreateReport = false
    },
    hideCreateReport() {
      this.showNewCreateReport = false
    },
    handleClose(done) {
      done()
    },
    async hideDetail() {
      this.showNewCreateReport = false
      await this.getList()
    },
    showImage(record) {
      this.imageDialog = true
      console.log(record.receipts)
      const items = []
      for (const i in record.receipts) {
        items.push(record.receipts[i].url)
      }
      this.imageList = items
    },
    previewImage(ref, fileId, source) {
      this.$refs[ref].showViewer = true
      this.currentFileId = fileId
      this.currentFileType = source
    },
    queryList() {
      this.loading = true
      this.queryForm.page = 1
      this.result = {
        list: [],
        cnt: 0
      }
      this.getList()
      this.loading = false
    },
    filterHandler(value, row, column) {
      const property = column['property']
      return row[property] === value
    },
    quickQuery(state) {
      this.queryForm.states = ['' + (state)]
      this.queryList()
    },
    getList() {
      getReportList(this.queryForm).then((res) => {
        if (res.data.data) {
          this.result.list = res.data.data.list
          this.result.cnt = res.data.data.total
        }
      })
    },
    changeBrand(val) {
      this.searchStore()
    },
    changeMarket(val) {
      this.searchStore()
    },
    changeCity(val) {
      this.marketLists(val)
      this.searchStore()
    },
    getBrandList() {
      getBrandList().then((res) => {
        if (res.data.data) {
          this.brands = res.data.data
        }
      })
    },
    getCityList() {
      getCityList().then((res) => {
        if (res.data.data) {
          this.cities = res.data.data
        }
      })
    },
    marketLists(cityId) {
      getMarketList({city_id: cityId}).then((res) => {
        if (res.data.data) {
          this.markets = res.data.data
          console.log('markets...', this.markets)
        }
      })
    },
    searchStore() {
      getShopList(this.queryForm).then((res) => {
        if (res.data.data) {
          this.shops = res.data.data
        }
      })
    },
    showDetail(row) {
      this.showReimbursement = true
      this.appo_task_id = row.appo_task_id
      this.reim_id = row.reim_id
    },
    showReport(row) {
      console.log('xxxxxxxx', row)
      this.order_detail = row
      this.report_id = row.id
      this.order_id = row.order_id
      this.ma_item_id = row.ma_item_id
      this.showCreateReport = true
    },
    createOrderReport(row) {
      console.log('report........row....', row)
      this.order_detail = row
      this.order_id = row.order_id
      this.order_supplier_id = row.order_supplier_id
      this.ma_item_id = row.ma_item_id
      this.showCreateReport = true
    },
    closeDetail() {
      this.quotationDialog = false
      this.reportDialog = false
      this.getList().then((res) => {
        if (res.data.code > 0) {
          this.$message.error(res.data.msg)
        } else {
          for (let i = 0; i < this.result.list.length; i++) {
            if (this.result.list[i].id === this.detailData.id) {
              this.result.list[i] = res.data.data.list[0]
              this.$set(this.result.list, i, this.result.list[i])
            }
          }
        }
      }).catch((e) => {
        console.log(e)
      })
    },
    handleSizeChange(val) {
      this.queryForm.pageSize = val
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.queryForm.page = val
      this.getList()
    },
    showReimbursementDetail() {

    }
  }
}
</script>
<style>
.app-container {
  width: 90%;
  margin: 0 auto;
}
.el-select-dropdown__wrap {
  max-height: 420px !important;
}
</style>
<style scoped lang="less">
.button {
  margin: 5px;
}
.opeartion{
  display: flex;
  flex-direction: column;
  justify-content: center;

  button{
    width: 100%;
    margin-left: 0  !important;
    margin-top: 8px;
    padding: 6px;
    text-align: center;
  }
}
.isAdvanced{
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    width: 20px;
    text-align: center;
    font-weight: bold;
    cursor: pointer;
  }

  .Y{
    &.active{
      color: #409EFF;
    }
  }
  .N{
    &.active{
      color: #F56C6C;
    }
  }
  .NA{
    width: 24px;
    &.active{
      color: #67c23a;
    }
  }
}
</style>
<style lang="less">
.el-drawer.rtl {
  overflow: auto;
}
.select-all > .el-scrollbar > .el-select-dropdown__wrap {
  max-height: 100%;
}
.label-box{
  color:  #3a8ee6;
}
.app-container.reimbursement-manager{
  height: 100%;
  .el-table{
    height: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
    .el-card__header{
      min-height: 55px;
    }
    .el-card__body{
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow: auto;
    }
  }
  .el-image-own{
    position: relative;
    &::after{
      content: '签收单';
      position: absolute;
      top: 6px;
      left: 2px;
      color: #409EFF;
      cursor: pointer;
      pointer-events:none;
      font-weight: 500;
    }
    &>img{
      opacity: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/order/report_list_pc.vue